import Command from '@ckeditor/ckeditor5-core/src/command';

export default class LPFilloutCommand extends Command {
	execute( { filloutId, filloutText } ) {
		const editor = this.editor;

		editor.model.change( writer => {
			// Create a <placeholder> elment with the "name" attribute...
			const lpfillout = writer.createElement( 'lpfillout', { filloutid: filloutId, fillouttext: filloutText } );

			// ... and insert it into the document.
			editor.model.insertContent( lpfillout );
			// this.getSelectedText();

			// Put the selection on the inserted element.
			// writer.setSelection( lpformula, 'on' );
		} );
	}

	refresh() {
		const model = this.editor.model;
		const selection = model.document.selection;

		// const isAllowed = model.schema.checkChild( selection.focus.parent, 'lpformula' );

		// this.isEnabled = isAllowed;
		const isAllowed = model.schema.checkChild( selection.focus.parent, 'lpfillout' );
		// const isAllowed = model.schema.checkAttributeInSelection( selection, 'formula' );

		this.isEnabled = isAllowed;
	}
}
